import { render, staticRenderFns } from "./ReconnectForm.vue?vue&type=template&id=36263aec&scoped=true&"
import script from "./ReconnectForm.vue?vue&type=script&lang=js&"
export * from "./ReconnectForm.vue?vue&type=script&lang=js&"
import style0 from "./ReconnectForm.vue?vue&type=style&index=0&id=36263aec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36263aec",
  null
  
)

export default component.exports